<template >
  <div>
    <el-upload
      ref="upload"
      :auto-upload="true"
      :data="access"
      :action="action"
      accept=".jpg, .jpeg, .png, .gif, .doc, .docx, .txt, .xls, .xlsx, .pdf,.PDF"
      :multiple="IsMultiple"
      :before-upload="beforeUpload"
      :on-remove="onRemoveHandler"
      :before-remove="beforeRemove"
      :on-success="onSuccessHandler"
      :on-error="onError"
      :show-file-list="true"
      :on-preview="handlePreview"
      :disabled="IsUpload==false"
      :on-exceed="fileLimit"
      :limit="8"
      :file-list="fileLists"
    >
      <el-button type="primary" size="small" v-if="IsUpload">点击上传</el-button>
    </el-upload>

      <!--课件预览-->
      <div class="PreviewResourcces" v-show="dialogVisiblePreviewResources">
        <!-- <i @click="dialogClose()" style="color:red;font-size:35px;position: fixed;top: 100px;z-index:1000" class="el-icon-close icon-closeimg"></i> -->
        <PreparingCourseware v-if="dialogVisiblePreviewResources" :sourceId="docId" :savesession="false" @dialogVisiblePreviewResources="dialogClose()"></PreparingCourseware>
      </div>
  </div>
</template>

<script>
import uploader from "lib/mixins/uploader";
import PreparingCourseware from 'components/PreparingCourseware.vue';
// import func from '../../../vue-temp/vue-editor-bridge';
export default {
  mixins: [uploader],
  props: {
    IsUpload: {
      type: Boolean,
      default: true
    },
    IsMultiple: {
      type: Boolean,
      default: true
    },
    fileLists: {
      type: Array,
      default: () => {
        return [];
      }
    },
    files:{
      type: Array,
      default: () => {
        return [];
      }
    },
    IsPreview:{
      type: Boolean,
      default: false
    }
  },
  components: {
    PreparingCourseware
  },
  data() {
    return {
      docId: "",
      sourceFiles: [],
      materialids: [],
      imgsList: [],
      imgUrl: "",
      indexCount: 0,
      docId: '',
      dialogVisiblePreviewResources: false,
    };
  },
  created() {
    this.fileLists.forEach(ele=>{
      this.materialids.push({
        docId: ele.id,
        docTitle:ele.name
      });
    });

    // this.fileLists
    
    // that.sourceFiles.push({
    //   title: res.fileName,
    //   url: data,
    //   status: rst.status
    // });

  },
  watch: {
    fileLists: function(val){
      val.forEach(ele => {
        this.materialids.push(ele.id);
      });
    }
  },
  methods: {
    dialogClose() {
      this.dialogVisiblePreviewResources = false;
    },
    uploadFile() {},
    fileLimit() {
      this.$message.warning("一次最多上传8个文件");
    },
    beforeUpload(file) {
      const ext = file.name.split(".").pop();
      return (
        [
          "jpg",
          "jpeg",
          "png",
          "gif",
          "doc",
          "docx",
          "txt",
          "xls",
          "xlsx",
          "pdf",
          "PDF"
        ].includes(ext) && this.addFile(file)
      );
    },
    onRemoveHandler(file) {
      var that = this;
      debugger;
      var fileIndex = 0;
      that.materialids.forEach((element,index) => {
        if(element.docId == file.id){
          fileIndex = index;
          return;
        }
      });
      // var index = that.materialids.indexOf(file.id);
      that.materialids.splice(fileIndex,1);
      this.$emit("done", that.materialids);
    },
    beforeRemove(file, fileList) {},
    handlePreview(file) {

      if(file.id){
        this.dialogVisiblePreviewResources = true;
        this.docId = file.id;
      }else{
        this.dialogVisiblePreviewResources = true;
        this.docId = file.response.docId;
      }
    },
    onSuccessHandler(res, file, uploadFiles) {
      var that = this;
      this.$http
        .post("/api/XOrg/AttestationActivity/getScreenCourseWareInfo", {
          courseWareId: res.docId
        })
        .then(function(rst) {
          var data = [];
          // 判断是否是单张图片
          if (
            rst.category != "jpg" &&
            rst.category != "jpeg" &&
            rst.category != "png" &&
            rst.category != "gif"
          ) {
            var imgs = [];

            var statusUrl = rst.urls.preview_oss_gen;

            // 拼接图片的地址
            for (var i = 0; i < rst.args_page_count; i++) {
              data.push(statusUrl + (i + 1) + ".png");
            }
          } else {
            data = [res.docPath];
          }

          that.sourceFiles.push({
            title: res.fileName,
            url: data,
            status: rst.status
          });
        });

      this.IsShowUpload = false;
      // 执行mixins里的onSuccess, 继续下一个文件
      if (this.onSuccess) {
        this.onSuccess(res, file, uploadFiles);
      }
      if (res.code > 0) {
        file.url = res.docPath;
      }
      debugger;
      this.materialids.push({
        docId: res.docId,
        docTitle:file.name
      });
      this.$emit("done", this.materialids);
    }
  }
};
</script>

<style lang="scss">
.PreviewResourcces {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2010;
  background-color: rgba(0, 0, 0, 1);
  width: 100%;
  height: 100%;
  overflow: auto;
  .icon-closeimg {
    size: 26px;
    position: fixed;
    top: 20px;
    right: 20px;
    font-size: 35px;
    cursor: pointer;
    font-weight: bolder;
  }
}
.el-col-8 {
  margin-top: 15px;
  width: 100%;
}
.preview-class-content {
  max-width: 100%;
}
</style>
